'use strict';

// based on: http://stackoverflow.com/a/14719818/751

module.exports = function (input, regex) {
	var $input = window.jQuery(input);
	var cursor = $input[0].selectionStart;
	var value = $input.val();

	if (regex.test(value)) {
		$input.val(value.replace(regex, ''));
		cursor--;
	}
	$input[0].setSelectionRange(cursor, cursor);
};
